import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=95f7b0b6&scoped=true&"
import script from "./PointDetail.vue?vue&type=script&lang=js&"
export * from "./PointDetail.vue?vue&type=script&lang=js&"
import style0 from "./PointDetail.vue?vue&type=style&index=0&id=95f7b0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f7b0b6",
  null
  
)

export default component.exports